import React from 'react'
import type { RadioGroupProps as MuiRadioGroupProps } from '@material-ui/core/RadioGroup'
import MuiRadioGroup from '@material-ui/core/RadioGroup'

export type RadioGroupProps = MuiRadioGroupProps

const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(function RadioGroup(props, ref) {
  return <MuiRadioGroup ref={ref} {...props} />
})

export default RadioGroup
